// @flow

import { useEffect, useState } from "react"
import debounce from "lodash/debounce"
import { sizes } from "../utils/media"

export default (): boolean => {
  const [isMobile, setIsMobile] = useState(false)

  const onResize = debounce(() => {
    const updatedValue = window.innerWidth < sizes.phone

    setIsMobile(updatedValue)
  }, 200)

  useEffect(() => {
    onResize()
    window.addEventListener("resize", onResize)

    return () => {
      window.removeEventListener("resize", onResize)
    }
  }, [])

  return isMobile
}
